export default (params) => ({
  trigger: {
    name: 'order_block_summary.add_to_cart',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      order_type: {
        enum: [
          'purchase',
          'subscription',
          'lease',
        ],
      },
    },
    event: {
      name: 'add_to_cart',
      params: {
        sub_feature: null,
        index: 1,
        total_indices: 1,
      },
    },
  },
});
